// ---------------------------------------------------------------------------
// Puntuación de cuestionarios "scale" (0/1/2) dentro de actividades structured.
// Calcula subtotales por bloque (heading), total y nivel de resultado.
// ---------------------------------------------------------------------------

const POINTS_PER_SCALE = 2;

// Suma las respuestas de los campos "scale", agrupando por encabezado.
export function computeScore(fields = [], values = {}) {
  const groups = [];
  let current = null;
  let total = 0;
  let max = 0;
  let scaleCount = 0;

  for (const field of fields) {
    if (field.type === "heading") {
      current = { label: field.label, subtotal: 0, max: 0 };
      groups.push(current);
      continue;
    }

    if (field.type === "scale") {
      const parsed = parseInt(values[field.id], 10);
      const value = Number.isNaN(parsed) ? 0 : parsed;

      total += value;
      max += POINTS_PER_SCALE;
      scaleCount += 1;

      if (current) {
        current.subtotal += value;
        current.max += POINTS_PER_SCALE;
      }
    }
  }

  return {
    total,
    max,
    scaleCount,
    groups: groups.filter((g) => g.max > 0),
  };
}

// Devuelve el nivel cuyo rango [min, max] contiene el total.
export function getLevel(total, levels = []) {
  if (!Array.isArray(levels)) return null;
  return (
    levels.find(
      (l) => total >= (l.min ?? 0) && total <= (l.max ?? Infinity)
    ) || null
  );
}

// Clases Tailwind por "tono" de nivel (con fallback neutro).
export const LEVEL_TONES = {
  red: "bg-red-50 border-red-200 text-red-700",
  amber: "bg-amber-50 border-amber-200 text-amber-700",
  blue: "bg-blue-50 border-blue-200 text-blue-700",
  emerald: "bg-emerald-50 border-emerald-200 text-emerald-700",
};

export function levelToneClass(tone) {
  return LEVEL_TONES[tone] || "bg-gray-50 border-gray-200 text-gray-700";
}
